import { RankForm } from "./RankForm";

const EditRank = () => {
  return <RankForm edit />;
};

export { EditRank };
